<template>
   <div :style="cardStyle">
       <div class="item__header" @click="toggleItems()">
           <span class="item__icon" >
            <filterIcon v-if="icon" :icon="icon" color="#ffffff"/>
            <small  v-if="!hideChildren && childrens" :style="branchHieght"></small>
        </span>
           <span class="item__title">{{title}}</span>
           <span v-if="iconAfter" class="arrow__down"></span>
           <span v-else></span>
           <span class="left__wall"></span>
       </div>
       <transition name="fade">
            <div class="item__children" v-if="!hideChildren && childrens && toggle">
                <ul>
                    <li v-for="(child,index) in childrens" :key="index">
                        <input type="checkbox" :name="child" :value="child" :id="child+index" :checked="$store.state.checkedfilters.includes(child)" @change="selectChild($event.target)">
                        <label :for="child+index"><span></span>{{child}}</label>
                    </li>
                </ul>
            </div>
        </transition>    
   </div>
</template>

<script>
import filterIcon from './Icon.vue'
export default {
    components : { filterIcon },
    props : { 
        title : { type : String, default: "Title"},
        childrens : { type : Array, default: null},
        icon : { type : String, default: null},
        paddingX : { type :Number, default: 0},
        paddingY : { type :Number, default: 0},
        iconAfter : { type : Boolean, default : true},
        toggle : { type : Boolean, default : true}
    },
    data(){
        return {
            selectedChilrens : [],
            hideChildren : true,

        }
    },
    computed :{ 
        branchHieght(){
            let height = 3.4;
            let childrensNumber = this.childrens.length;
            if(childrensNumber > 1) return {height:height+((childrensNumber-1)*2)+'rem'};
            else if (childrensNumber == 1) return {height:height+'rem'};
            else return {height:0};
        },
        cardStyle(){
            return {
                padding : `${this.paddingY}rem ${this.paddingX}rem`
            }
        }
    },
    methods : { 
        selectChild(e) {
            if(e.checked) {
                this.selectedChilrens.push(e.value);
                this.$store.state.checkedfilters.push(e.value)
                }
            else {
                this.selectedChilrens.splice(this.selectedChilrens.indexOf(e.value),1)
                this.$store.state.checkedfilters.splice( this.$store.state.checkedfilters.indexOf(e.value),1)
                }
            this.$emit('input',this.selectedChilrens)
        },
        toggleItems(){
            this.hideChildren = !this.hideChildren;
            if(!this.childrens) this.$emit('handleClick');
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .item__header {
        display : flex;
        align-items: center;
        justify-content: space-between;
        background-color: #F2F3F9; 
        position: relative;
        padding: 1rem;
        cursor: pointer;
        border-bottom: 1px solid #E8EAF0;
        .left__wall {
            border : 1px solid #646464;
            background-color: #353B45;
            padding : 1.2rem .2rem;
            position : absolute;
            left: 0;
            border-radius: 0 1rem 1rem 0;
        }
    }
    .arrow__down {
        padding : .8rem;
        background-color: #000000d1;
        border-radius: 50%;
        position : relative;
        &:after {
            content: '';
            position: absolute;
            border-top: 2px solid rgb(255, 255, 255);
            border-right: 2px solid rgb(255, 255, 255);
            height: .4rem;
            width: .4rem;
            transform: rotate(130deg);
            margin-right: .5rem;
            top : 37%;
            right : 7%;
        }
    }
    .item__title {
        font-weight: 400;
        font-size: 1.3rem;
    }
    .item__icon {
        padding: 0.6rem 0.6rem;
        background-color: #353B45;
        border-radius: 50%;
        position : relative;
        display: flex;
        align-items : center;
        justify-content : center;
        position: relative;
        color : #ffffff;
        small{
            border-left: 1px dashed #6c6c6c;
            position: absolute;
            top: 1.9rem;
            height: 2.6rem;
        }
    }
     
    .item__children {
        padding: .5rem 2.5rem;
        max-width : 100%;
        li {
            list-style: none;
            font-weight: 500;
            display : flex;
            align-items: center;
            padding: .2rem 0;
            z-index: 3;
            position:relative;
            &:after {
                content: '';
                border-top: 1px dashed #6c6c6c;
                position: absolute;
                left: -1.9rem;
                width: 1.7rem;
            }
            label {
                margin : 0;
                cursor: pointer;
                display : flex;
                align-items : center;
                span:last-child {
                    border : 1px solid #767676;
                    padding: .4rem;
                    border-radius: .2rem;
                    position: relative;
                    margin-right: .5rem;
                    &:after {
                        content: '';
                        position: absolute;
                        border-top: 2px solid rgb(255, 255, 255);
                        border-right: 2px solid rgb(255, 255, 255);
                        height: .4rem;
                        width: .4rem;
                        transform: rotate(130deg);
                        margin-right: .5rem;
                        top: 14%;
                        left: 14%;
                        padding: 0 0.2rem;
                        
                    }
            }
            }
            input[type=checkbox] {
                display: none;
            }
            input[type=checkbox]:checked ~ label span{
                background-color: #333;
            }
          
        }
    }
    .fade-enter-active, .fade-leave-active {
        transform : translateY(500px);
    }
    .fade-enter, .fade-leave-to  {
        transform : translateY(500px);
        opacity: 0;
    }
  
</style>


// WEBPACK FOOTER //
// src/components/global/ToggleNav.vue